import { action, makeObservable, observable, runInAction } from 'mobx'
import { ISelectOption } from 'src/Models/Client'
import { GetCurrentMonthOption, GetCurrentYear } from 'src/Helpers/DateHelpers'
import { IMonthYear } from 'src/Models/Client'
import IGenericError from 'src/Models/Server/IGenericError'
import { SelectOptionsFromNameGuidVTO } from 'src/Models/Server/INameGuidVTO'
import CurrencyController from 'src/Services/ToprCoreApi/Axios/Controllers/CurrencyController'
import MerchantController from 'src/Services/ToprCoreApi/Axios/Controllers/MerchantController'
import ReportController from 'src/Services/ToprCoreApi/Axios/Controllers/ReportController'
import { appUiStore } from 'src/Stores/AppUiStore'
import BaseStore from 'src/Stores/BaseStore'

export interface IFormValues {
  SelectedMonthYear: IMonthYear
  SelectedMerchant: ISelectOption
  SelectedCurrency: ISelectOption
}

export default class Store extends BaseStore<IFormValues> {
  public CurrencyOptions: ISelectOption[] = []
  public MerchantOptions: ISelectOption[] = []

  constructor() {
    super()
    makeObservable(this, {
      MerchantOptions: observable,
      CurrencyOptions: observable,
      Initialize: action,
      GetFilter: action,
      GetSiedlerInvoiceCurrency: action,
    })
  }

  public Initialize() {
    this.ViewModel = undefined
    this.CurrencyOptions = []
    this.MerchantOptions = []

    this.GetFilter()
  }

  public GetFilter() {
    this.IsLoading = true

    Promise.all([
      MerchantController.GetMyMerchants(),
      CurrencyController.GetMyMerchantCurrencies(),
    ])
      .then((values) => {
        runInAction(() => {
          const merchantOptions = SelectOptionsFromNameGuidVTO(values[0])
          const currencyOptions = values[1].map((c) => {
            return { value: c.CurrencyGuid, label: c.Name }
          })

          this.ViewModel = {
            SelectedMonthYear: {
              Month: GetCurrentMonthOption().value,
              Year: GetCurrentYear().toString(),
            },
            SelectedCurrency:
              currencyOptions.length > 0 ? currencyOptions[0] : undefined,
            SelectedMerchant:
              merchantOptions.length > 0 ? merchantOptions[0] : undefined,
          }
          this.CurrencyOptions = currencyOptions
          this.MerchantOptions = merchantOptions
          this.IsLoading = false
        })
      })
      .catch((error: IGenericError) => {
        runInAction(() => (this.IsLoading = false))
        appUiStore.ShowError(error)
      })
  }

  public GetSiedlerInvoiceCurrency(data: IFormValues) {
    this.IsSubmitting = true
    ReportController.GetSiedlerInvoiceCurrency(
      data.SelectedMonthYear,
      data.SelectedMerchant,
      data.SelectedCurrency
    )
      .then(() => {
        runInAction(() => (this.IsSubmitting = false))
      })
      .catch((error: IGenericError) => {
        runInAction(() => (this.IsSubmitting = false))
        appUiStore.ShowError(error)
      })
  }
}

export const siedlerInvoiceCurrencyStore = new Store()
